<template>
  <div class="success">
    <div class="select-os">
        <input type="radio" id="japanese" name="launguage" v-model="style" value="0" class="japanese" checked>
        <label for="japanese">
            日本語
        </label>
        <input type="radio" id="english" name="launguage" v-model="style" value="1" class="english">
        <label for="english">
            English
        </label>
    </div>
    <div id="top">
      <div class="card-content" v-if="style === '0'">
        <h1><img src="https://kirarin-covid19.com/img/siteid.png" ></h1>
        <h2>{{ name }}を完了しました。</h2>
        <p>{{ description }}</p>
        <p v-show="isCredential">{{ credential }}</p>
        <a href="/contact?style=0">お問い合わせへ</a>
      </div>
      <div class="card-content" v-else>
        <h1><img src="https://kirarin-covid19.com/img/siteid.png" ></h1>
        <h2>Success for{{ name }}</h2>
        <p>{{ description }}</p>
        <p v-show="isCredential">{{ credentialEn }}</p>
        <a href="/contact?style=0">Contact</a>
      </div>
    </div>
  </div>
</template>
<style scoped>
h1{
 margin: 0px;
}
body{
  margin: 0px;
}
.select-os{
  text-align: end;
  margin-top: 2em;
  margin-right: 2em;
}
.select-os input {
  display: none;
}
.select-os input[type="radio"]:checked.japanese + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os input[type="radio"]:checked.english + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os label {
  color: #ddd;
  border: 2px solid #ddd;
  text-align: center;
  display: inline-block;
  padding: 5px 0px;
  width: 120px;
}
.select-os label:hover {
    color: #aaa;
    border: 2px solid #aaa;
    cursor: pointer;
}
.card-content{
  width: 80%;
    margin: 0 auto;
    text-align: left;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateY(-50%) translateX(-50%);
    transform: translateY(-50%) translateX(-50%);
}
a{display: block;
  width: 80%;
  line-height: 40px;
  height: 40px;
  margin: 8% auto;
  text-align: center;
  font-size: 1em;
  text-align: center;
  background: #5D99FF;
  text-transform: uppercase;
  text-decoration: none;
  color: white;
  border:0px;
  border-radius: 4px;}
@media screen and (max-width:780px) {
  .select-os{
  position: inherit;
  top: 0px;
  right: 0em;
  text-align: center;
    margin-top: 2em;
    margin-bottom: 2em;
    position: inherit;
    top: 0px;
}
  }
</style>
<script>
import $ from 'jquery'
import Footer from './common/Footer'
export default {
  name: 'Error',
  components: {
    Footer
  },
  data () {
    return {
      name: '',
      description: '',
      plan: null,
      isCredential: false,
      credential: '連絡先(株式会社 Kirarin):03-6384-0230　担当者(村上)：080-6769-4747',
      credentialEn: 'Kirarin　Inc.(company):03-6384-0230 Murakami(staff):080-6769-4747',
      style: '0'
    }
  },
  created: function () {
    // 引数によって成功ページを表示
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }

    // 購入したプラン
    this.plan = parseInt(result['plan'], 10)
    this.style = result['style']

    // 引数がない場合は不正アクセス
    if (!this.plan) {
      if (this.plan != 0) {
        if (this.style === '0') {
          alert('不正アクセスの可能性があります、お問い合わせページから担当へご連絡ください。')
        } else {
          alert('There is a possibility of unauthorized access.Please make inquiries using the contact form.')
        }
        this.loading = false
        location.href = "/contact?style=" + this.style
      }
    }

    // 
    if (this.plan === 0) {
      // 宿泊者様PCR検査
      if (this.style === '0') {
        this.name = '宿泊者様PCR検査の購入'
        this.description = 'ユーザー認証時に登録したメールに購入情報の詳細をお送りしております。こちらのメール画面をホテル内のコンシェルジュデスクにお持ちして、PCR検査のキットがお部屋に届くまでお待ちいただければと思います。何かご不明点があれば、以下のボタンからお問い合わせをお願いいたします。'
      } else {
        this.name = 'Purchase to take a PCR test'
        this.description = 'We sent the details about purchase history by email. Please show us this email at the concierge desk and wait until PCR kit arrives in your room. If you have any questions, please notify us at the following button.'
      }
      return
    } else if (this.plan === 1) {
      // パーティ参加者様事前PCR検査
      if (this.style === '0') {
        this.name = 'パーティ参加者様事前PCR検査の申し込み完了'
        this.description = 'パーティ参加者様事前PCR検査の申し込みを受付ました。3営業日以内にホテル内のコンシェルジュデスクからご連絡届くのでお待ちいただければと思います。何かご不明点があれば、以下のボタンからお問い合わせをお願いいたします。'
      } else {
        this.name = 'Application completed about PCR test in advance for party guests.'
        this.description = 'Application completed about PCR test in advance for party guests. You can get a message from our concierge desk within 3 business days.If you have any questions, please notify us at the following button.'
      }
      
    } else if (this.plan === 2) {
      if (this.style === '0') {
        this.name = '海外渡航陰性証明書の購入'
        this.isCredential = true
        this.description = '海外渡航陰性証明書の購入を完了しました。ご予約が確認でき次第折り返しお電話をさせていただきます。電話が来ない場合又は営業時間外の場合、コンシェルジュまでお問い合わせください。'
      } else {
        this.isCredential = true
        this.name = 'Purchase to take a PCR test negative certificate for overseas travel'
        this.description = 'Purchase to take a PCR test negative certificate for overseas travel completed.We will call you back as soon as your reservation is confirmed.Contact the concierge if you do not receive a call or are out of business hours.'
      }
      
    } else {
      if (this.style === '0') {
        this.name = '医師派遣＆抗原検査の購入'
        this.description = '医師派遣＆抗原検査の購入を完了しました。3営業日以内にホテル内のコンシェルジュデスクからご連絡届くのでお待ちいただければと思います。何かご不明点があれば、以下のボタンからお問い合わせをお願いいたします'
      } else {
        this.name = 'Purchase to take a dispatch of doctors plan & antigen test against COVID-19'
        this.description = 'Purchase to take a dispatch of doctors plan & antigen test against COVID-19 completed. You can get a message from our concierge desk within 3 business days.If you have any questions, please notify us at the following button.'
      }
      
    }    

  },
  methods: {
    sendContactCertificate: function () {
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Success.vue